module.exports = __webpack_public_path__ + "static/media/isabelle_stüssi.5cb294e3.jpg";